import cn from 'clsx'
import { ElementType, FC, PropsWithChildren } from 'react'

import { config } from './typography.config'
import { ITypography } from './typography.interface'

interface ExtendedTypographyProps extends ITypography {
	as?: ElementType
}

const Typography: FC<PropsWithChildren<ExtendedTypographyProps>> = ({
	as: Tag = 'p',
	variant,
	className,
	children,
	...props
}) => {
	const classes = cn(
		{
			[config[variant]]: variant
		},
		'whitespace-break-spaces',
		className
	)

	return (
		<Tag className={classes} {...props}>
			{children}
		</Tag>
	)
}

export default Typography
